import { render } from "./LotArea.vue?vue&type=template&id=4c52249a"
import script from "./LotArea.vue?vue&type=script&lang=js"
export * from "./LotArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/remy/Sites/baghera/woc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__